import { handleActions } from 'redux-actions';

export default handleActions(
	{
		UPDATE_ACCESS_TOKEN: (state, action) => ({
			...state,
			token: action.payload.token,
			type: action.payload.type,
			status: action.payload.status,
			message: action.payload.message,
		}),

		TOGGLE_EMAIL_EXIST: (state, action) => ({
			...state,
			emailExist: action.payload.toggle,
		}),

		LOGOUT_FULFILLED: state => ({
			...state,

			token: {
				accessToken: '',
				endAt: '',
				expiresIn: '',
				refreshToken: '',
			},

			type: '',
			status: 0,
			message: '',

			google: {
				value: '',
				id: null,
			},

			facebook: {
				value: '',
				id: '',
			},
		}),

		LOAD_CONFIG: (state, action) => ({
			...state,
			token: action.payload.token,
			type: action.payload.type,
		}),

		LOGIN_NORMAL_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		LOGIN_TRANSFER_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_GOOGLE_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_FACEBOOK_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		VERIFY_MOBILE_CODE_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		FORGET_PASSWORD_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		token: {
			accessToken: '',
			endAt: '',
			expiresIn: '',
			refreshToken: '',
		},
		type: '',
		google: {
			value: '',
			id: null,
		},

		facebook: {
			value: '',
			id: '',
		},

		emailExist: false,
		loginErr: false,
		forgetErr: false,

		bindType: '',

		googleEmail: '',
		googleId: '',

		fbEmail: '',
		fbId: '',

		mobileVerifyFail: false,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/auth.js